import Stack from "@mui/material/Stack";
import React from "react";
import JobDetailsCompleted from "./JobDetailsCompleted";
import JobDetailsInProgress from "./JobDetailsInProgress";
import JobDetailsFailed from "./JobDetailsFailed";
import { RightioWBSAPIModelsJobsLast } from "@utils/apis/wbs/model";

const name = "JobsList";

interface JobsListProps {
    setOpen: any
    setJobId: any
    type: "completed" | "progress" | "failed"
    jobs: Required<RightioWBSAPIModelsJobsLast>[]
}

const JobsList: React.FC<JobsListProps> = ({ setOpen, setJobId, jobs, type }) => {
    return (<Stack sx={{ maxHeight: 250, overflowY: "auto" }}>
        {type === "completed" && jobs.map((j, index: number) => (
            <JobDetailsCompleted key={index + j.jobId!} job={j} setOpen={setOpen} setJobId={setJobId} />))}
        {type === "progress" && jobs.map((j, index: number) => (
            <JobDetailsInProgress key={index + j.jobId!} job={j} setOpen={setOpen} setJobId={setJobId} />))}
        {type === "failed" && jobs.map((j, index: number) => (
            <JobDetailsFailed key={index + j.jobId!} job={j} setOpen={setOpen} setJobId={setJobId} />))}
    </Stack>)
}

JobsList.displayName = name;

export default React.memo(JobsList);